export const transformSectionsIntoUI = (tx) => {
  const updatedTX = {};
  if (!tx) return updatedTX;

  if (tx.cash) {
    updatedTX.cash = tx.cash;
  }

  if (tx.pc && tx.pc?.length > 0) {
    // pc: {transaction: [], paidAmount: {[id]:amount}}
    const transformedFunction = (item) => ({
      ...item,
      id: item._id,
      weight: item?.weight / (item.qty || 1),
      totalWeight: item.weight,
      totalAmount: item?.diffAmount,
    });

    const transformedPC = transformArraySection(tx.pc, transformedFunction);
    updatedTX.pc = transformedPC;
  }

  if (tx.lab && tx.lab?.length > 0) {
    const transformedFunction = (item) => ({
      ...item,
      id: item._id,
      testingPw: item.testingFeesPW,
      testingOa: item.testingFeesOA,
    });

    const transformedLab = transformArraySection(tx.lab, transformedFunction);
    updatedTX.lab = transformedLab;
  }

  //   bar
  if (tx.bar && tx.bar?.length > 0) {
    const tf = (item) => ({
      ...item,
      id: item._id,
      weight: item?.barWeight || 0,
      makingTotal: item.totalMaking,
    });

    const transformedBar = transformArraySection(tx.bar, tf);
    updatedTX.bar = transformedBar;
  }

  //   coin
  if (tx.coin && tx.coin?.length > 0) {
    const tf = (item) => ({
      ...item,
      id: item._id,
      weight: item?.coinWeight || 0,
    });

    const transformedCoin = transformArraySection(tx.coin, tf);
    updatedTX.coin = transformedCoin;
  }

  //   ginni
  if (tx.ginni && tx.ginni?.length > 0) {
    const tf = (item) => ({
      ...item,
      id: item._id,
      weight: item?.ginniWeight || 0,
    });

    const transformedGinni = transformArraySection(tx.ginni, tf);
    updatedTX.ginni = transformedGinni;
  }

  //silver
  if (tx.silver && tx.silver.length > 0) {
    const tf = (item) => ({
      ...item,
      id: item._id,
      rawal: item?.rawalRod || 0,
    });

    const tansformedSilver = transformArraySection(tx.silver, tf);
    updatedTX.silver = tansformedSilver;
  }
  // gold rate work
  if (tx.goldRateWork) {
    updatedTX.goldRW = tx.goldRateWork;
  }

  //   Silver rate work
  if (tx.silverRateWork) {
    updatedTX.silverRW = tx.silverRateWork;
  }

  return updatedTX;
};

function transformArraySection(barArray = [], transformFn = (item) => item) {
  const transformedItems = barArray.map(transformFn);

  return {
    transactions: transformedItems,
    paidAmounts: Object.fromEntries(
      transformedItems.map((item) => [item._id, item.paidAmount ?? 0]),
    ),
  };
}

const getRate = (weight) => {
  return {
    rate: {
      weight: weight,
      rate: "",
      diff: "",
      amount: "",
      totalAmount: "",
    },
  };
};
